<template>
  <div>
    <div v-if="selectedItem.fieldType === 'checkbox'" class="doc-with-checkbox text-left mb-48">
      <div class="custom-control form-control-lg custom-checkbox d-flex align-items-center">
        <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="inputValue" @change="validate" />
        <label class="custom-control-label" @click="inputValue = ~inputValue" for="customCheck1">{{ selectedItem.fieldLabel }}</label>
      </div>
      <p>{{ selectedItem.fieldInstruction }}</p>
    </div>
    <div v-else-if="selectedItem.fieldType === 'text'" class="doc-with-label text-left">
      <p class="pt-24">{{ selectedItem.fieldLabel }}</p>
      <div class="textarea-wrap">
        <div class="form-group pt-24">
          <label for="doc-with-label">{{ selectedItem.fieldInstruction }}</label>
          <textarea class="form-control secondary-border" id="doc-with-label" v-model="inputValue" @keyup="validate" rows="3"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DocumentInputField",
  props: ["field", "value", "valid"],
  data() {
    return {
      selectedItem: this.field,
      inputValue: this.value
    };
  },
  mounted() {
    this.setup();
  },
  watch: {
    field(val) {
      this.selectedItem = val;
      this.setup();
    },
    value(val) {
      this.inputValue = val;
    }
  },
  methods: {
    setup() {
      if (["text", "checkbox"].indexOf(this.selectedItem.fieldType) === -1) {
        this.$emit("validated", true);
        this.$emit("input", true);
        this.inputValue = true;
      } else {
        this.inputValue = this.selectedItem.fieldType === "text" ? "" : this.selectedItem.fieldType !== "checkbox";
      }
    },
    validate() {
      this.$emit("input", this.inputValue);
      if (this.selectedItem.fieldType === "text" && this.inputValue != "") {
        this.$emit("validated", true);
      } else if (this.selectedItem.fieldType === "checkbox" && this.inputValue) {
        this.$emit("validated", true);
      } else {
        this.$emit("validated", false);
      }
    }
  }
};
</script>
